import React, { useEffect, useState, useRef, useContext } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  InputGroup,
  Nav,
} from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { Context } from "../../../../utils/context";
import Animation from "../../../RecruiterPage/LoginSignUp/login-page/animation/Animation";
import { GoogleOAuthProvider, GoogleLogin } from "@react-oauth/google";
import ContactModal from "../ContactModal/ContactModal";
import SignUpModal from "../SignUpModal/ContactModal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebookF, faInstagram } from "@fortawesome/free-brands-svg-icons";

const GetotpJobseeker = () => {
  const { postData, PostGoogleLogin, setSignin, setUsertype } =
    useContext(Context);
  const navigate = useNavigate();

  // Track the active login role type: 'jobseeker' or 'recruiter'
  const [loginType, setLoginType] = useState("jobseeker");

  const [phone, setPhone] = useState("");
  const [mobileErr, setMobileErr] = useState("");
  const [otpERR, setOtpErr] = useState("");
  const [otpsend, setOtpSend] = useState(null);
  const [authToken, setAuthToken] = useState(null);
  const [authType, setAuthType] = useState(null);
  const [steps, setSteps] = useState(null);
  const [modalShow, setModalShow] = useState(false);
  const [signModalShow, setSignModalShow] = useState(false);
  const [timerShow, setTimerShow] = useState(false);
  const [seconds, setSeconds] = useState(60);
  const [isTimerExpired, setIsTimerExpired] = useState(true);
  const [otpValues, setOtpValues] = useState(["", "", "", ""]);
  const inputRefs = [useRef(), useRef(), useRef(), useRef()];

  const handleValidation = async () => {
    var mobile = phone;
    var errors = [];

    if (mobile?.trim() === "") {
      setMobileErr("Mobile Number is required");
      errors.push("Mobile Number is required");
    } else if (!/^\d{10}$/.test(mobile)) {
      setMobileErr("Mobile Number should be a 10-digit number");
      errors.push("Mobile Number should be a 10-digit number");
    }

    if (errors.length === 0) {
      setMobileErr("");
      const randOtp = Math.floor(1000 + Math.random() * 9000).toString();

      // Dynamically hit the correct endpoint based on selected role
      const endpoint =
        loginType === "recruiter"
          ? "/without-login/recruiter/sign-in"
          : "/without-login/jobseeker/sign-in";

      const res = await postData(endpoint, {
        contact_no: "91" + mobile,
        otp: randOtp,
      });

      if (res?.success) {
        setAuthToken(res.data.token);
        setAuthType(res.data.type);
        setSteps(res.data.steps);
        setOtpSend(randOtp);
        setModalShow(true);
        setTimerShow(true);
        setIsTimerExpired(false);
        setOtpErr("");
        setOtpValues(["", "", "", ""]);
        setSeconds(60);
        setTimeout(() => {
          setModalShow(false);
        }, 4000);
      } else {
        setMobileErr(res?.message);
      }
    }
  };

  const handleOtpChange = (index, event) => {
    setOtpErr("");
    const inputValue = event.target.value;

    if (/^[0-9]*$/.test(inputValue) || inputValue === "") {
      otpValues[index] = inputValue;
      setOtpValues([...otpValues]);

      if (otpsend === otpValues.join("")) {
        setOtpErr("");
        setOtpValues(["", "", "", ""]);
        Cookies.set("echohouse_website", authToken, { expires: 1 });
        Cookies.set("jwtType", authType, { expires: 1 });
        setSignModalShow(true);
        setModalShow(true);

        setTimeout(() => {
          setSignModalShow(false);
          setOtpSend(null);
          setSignin(true);
          setUsertype(authType);

          if (loginType === "recruiter") {
            navigate("/dashboard-recruiter");
          } else {
            if (steps > 5) {
              navigate("/dashboard-job");
            } else {
              navigate(`/signup-job/${steps}`);
            }
          }
        }, 4000);
      } else if (inputValue !== "" && index < 3) {
        inputRefs[index + 1].current.focus();
      } else {
        setOtpErr("OTP Invalid!");
      }
    }
  };

  const handleKeyDown = (index, event) => {
    setOtpErr("");
    if (event.key === "Backspace" && index > 0 && otpValues[index] === "") {
      otpValues[index - 1] = "";
      setOtpValues([...otpValues]);
      inputRefs[index - 1].current.focus();
    }
  };

  const handleMobileChange = (event) => {
    const newValue = event.target.value.replace(/[^0-9]/g, "");
    setPhone(newValue);
    setMobileErr("");
  };

  const handleSuccess = async (data) => {
    const values = {
      token: data.credential,
      type: loginType === "recruiter" ? "Recruiter" : "Job Seeker",
    };
    const res = await PostGoogleLogin("/without-login/google-login", values);
    if (res?.success) {
      Cookies.set("echohouse_website", res.data.token, { expires: 1 });
      Cookies.set("jwtType", res.data.type, { expires: 1 });
      setSignModalShow(true);
      setTimeout(() => {
        setSignModalShow(false);
        if (loginType === "recruiter") {
          window.location.href = "/dashboard-recruiter";
        } else {
          if (res.data.steps > 9) {
            window.location.href = "/dashboard-job";
          } else {
            window.location.href = `/signup-job/${res.data.steps}`;
          }
        }
      }, 4000);
    } else {
      setMobileErr(res?.message);
    }
  };

  useEffect(() => {
    const decrementTimer = () => {
      if (seconds > 0) setSeconds(seconds - 1);
      else {
        setIsTimerExpired(true);
        setOtpSend(null);
      }
    };
    const timerInterval = setInterval(decrementTimer, 1000);
    return () => clearInterval(timerInterval);
  }, [seconds]);

  return (
    <>
      <Container fluid className="split-login-container p-0">
        <Row className="g-0 split_login_container_holder ">
          {/* LEFT PANEL - Graphics Showcase */}
          <Col
            lg={6}
            className="split-left-panel d-none d-lg-flex flex-column justify-content-between"
          >
            <div className="showcase-content-wrapper m-auto position-relative">
             
              <div className="animation-overlay-box">
                <Animation />
              </div>
            </div>
          </Col>

          {/* RIGHT PANEL - Authentication Panel */}
          <Col
            lg={6}
            xs={12}
            className="split-right-panel d-flex flex-column justify-content-between"
          >
            <div className="login-form-core m-auto w-100">
              {/* Dynamic Login Type Selector Tabs */}

              <div className="login-header-group mb-4">
                <h2>Welcome Back!</h2>
                <p className="login-subtitle text-muted">
                  Logging in as{" "}
                  <strong className="text-capitalize">Job Seeker</strong>
                </p>
              </div>

              {/* Mobile Input Field Group */}
              <Form.Group className="mb-3">
                <Form.Label className="field-top-label">
                  Mobile Number <span className="text-danger">*</span>
                </Form.Label>
                <InputGroup className="phone-input-combo">
                  <InputGroup.Text className="phone-prefix-addon">
                    +91
                  </InputGroup.Text>
                  <Form.Control
                    type="text"
                    minLength="10"
                    maxLength="10"
                    disabled={!isTimerExpired}
                    placeholder="Enter your 10-digit Mobile Number"
                    className="foundit-input-style"
                    onKeyDown={(event) => {
                      if (
                        !/[0-9]/.test(event.key) &&
                        event.key !== "Backspace"
                      ) {
                        event.preventDefault();
                      }
                    }}
                    onChange={handleMobileChange}
                  />
                </InputGroup>
                {mobileErr && (
                  <div className="error-hint-text text-danger mt-1 small">
                    {mobileErr}
                  </div>
                )}
              </Form.Group>

              {/* Main Dynamic Action Button */}
              <div className="submit-action-area mb-4">
                {!timerShow ? (
                  <Button
                    className="foundit-primary-btn active-state w-100"
                    onClick={handleValidation}
                  >
                    Send OTP
                  </Button>
                ) : isTimerExpired ? (
                  <Button
                    className="foundit-primary-btn active-state w-100"
                    onClick={handleValidation}
                  >
                    Resend OTP
                  </Button>
                ) : (
                  <Button className="foundit-primary-btn w-100" disabled>
                    OTP Sent
                  </Button>
                )}
              </div>

              {/* Security OTP Grid Fields */}
              {timerShow && !isTimerExpired && (
                <div className="otp-embedded-box text-center mb-4">
                  <p className="otp-alert-msg small text-muted">
                    Enter OTP within{" "}
                    {`${Math.floor(seconds / 60)}:${(seconds % 60).toString().padStart(2, "0")}`}{" "}
                    seconds
                  </p>
                  <div className="d-flex justify-content-center gap-2 my-2">
                    {otpValues.map((value, index) => (
                      <Form.Control
                        key={index}
                        className="otp-clean-input text-center"
                        type="text"
                        maxLength="1"
                        value={value}
                        onChange={(e) => handleOtpChange(index, e)}
                        onKeyDown={(e) => handleKeyDown(index, e)}
                        ref={inputRefs[index]}
                      />
                    ))}
                  </div>
                  {otpERR && (
                    <div className="error-hint-text text-danger small">
                      {otpERR}
                    </div>
                  )}
                </div>
              )}

              <div className="text-divider mb-4">
                <span>or continue with</span>
              </div>

              {/* Social Login Row */}
              <div className="oauth-row d-flex gap-3 mb-4">
                <div className="flex-grow-1 google-btn-wrapper ">
                  <GoogleOAuthProvider clientId="189802957201-b49b89i8t1t0cbcfuedll714lo1d2r0r.apps.googleusercontent.com">
                    <GoogleLogin
                      className="mx-auto"
                      onSuccess={handleSuccess}
                      onError={() => {}}
                    />
                  </GoogleOAuthProvider>
                </div>
              </div>
            </div>

            {/* Meta Segment Information Column Footer */}
            <div className="right-panel-footer border-top pt-4 mt-5">
              <Row className="text-start justify-content-between g-3">
                <Col md={12} xs={12} className="footer-sub-block text-center">
                  <h5 className="fw-bold mb-2">Employers Portal</h5>
                  <Button
                    size="sm"
                    variant="light"
                    className="employer-mini-btn border rounded-pill px-3"
                    onClick={() => navigate("/getotp")}
                  >
                    Switch to Recruiter
                  </Button>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </Container>

      <ContactModal show={modalShow} onHide={() => setModalShow(false)} />
      <SignUpModal
        show={signModalShow}
        onHide={() => setSignModalShow(false)}
      />
    </>
  );
};

export default GetotpJobseeker;
